
import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071';

const ProfileImage = ({
    profilePicture,
    profile_pic_base64,
    altName = 'User',
    className = "w-10 h-10 rounded-full object-cover border-2 border-white shadow-md",
    // API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071'
}) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [imageError, setImageError] = useState(false);
    const [triedBase64, setTriedBase64] = useState(false);

    useEffect(() => {
        // Reset states when props change
        setImageError(false);
        setTriedBase64(false);


        // Primary image source (proxy URL)
        if (profilePicture) {
            const proxyUrl = `${API_BASE_URL}/api/proxy-image?url=${encodeURIComponent(profilePicture)}`;
            setImageSrc(proxyUrl);
        } else if (profile_pic_base64) {
            // If no URL, try base64 directly
            console.log('No profilePicture, using base64 directly');
            setImageSrc(profile_pic_base64);
            setTriedBase64(true);
        } else {
            // No image sources available
            // console.log('No image sources available, showing placeholder');
            setImageError(true);
        }
    }, [profilePicture, profile_pic_base64, API_BASE_URL]);

    const handleImageError = (e) => {

        // Try base64 fallback if not already using it
        if (profile_pic_base64 && !triedBase64) {
            console.log('Trying base64 fallback');
            setImageSrc(profile_pic_base64);
            setTriedBase64(true);
        } else {
            // console.log('No more fallbacks, showing placeholder');
            setImageError(true);
        }
    };

    // Extract dimensions from className for placeholder
    const getPlaceholderClassName = () => {
        // Keep all classes except object-cover
        return className.replace(/object-cover\s?/, '');
    };

    // Show default placeholder if no image sources or both failed
    if (imageError || (!profilePicture && !profile_pic_base64)) {
        return (
            <div className={`bg-gradient-to-br from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-sm ${getPlaceholderClassName()}`}>
                👤
            </div>
        );
    }

    return (
        <img
            src={imageSrc}
            alt={`${altName} profile`}
            className={className}
            onError={handleImageError}
        // onLoad={() => console.log('Image loaded successfully:', imageSrc)}
        />
    );
};

export default ProfileImage;